import request from '@/utils/request'

/**
 * 获取 Wiki 列表（前台分页）
 */
export function getWikiPage(params = {}) {
  const normalizedParams = { ...params }

  if (params.page != null) {
    normalizedParams.pageNum = params.page
  }
  if (params.size != null) {
    normalizedParams.pageSize = params.size
  }
  if (params.categoryId != null) {
    normalizedParams.categoryId = params.categoryId
  }
  if (params.subcategoryId != null) {
    normalizedParams.subcategoryId = params.subcategoryId
  }
  if (params.parentCategory != null) {
    normalizedParams.parentCategory = params.parentCategory
  }
  if (params.category != null) {
    normalizedParams.category = params.category
  }

  return request({
    url: '/api/wikis/list',
    method: 'get',
    params: normalizedParams
  })
}

/**
 * 获取 Wiki 详情
 */
export function getWikiDetail(id) {
  return request({
    url: `/api/wikis/${id}`,
    method: 'get'
  })
}

/**
 * 获取 Wiki 预览地址（可选 fileId 指定具体 PDF，默认第一个）
 */
export function getWikiPreview(id, fileId) {
  return request({
    url: `/api/wikis/${id}/preview`,
    method: 'get',
    responseType: 'blob',
    params: fileId ? { fileId } : {}
  })
}

/**
 * 下载 Wiki PDF（可选 fileId 指定具体 PDF，默认第一个）
 */
export function downloadWikiPdf(id, fileId) {
  return request({
    url: `/api/wikis/${id}/download`,
    method: 'get',
    responseType: 'blob',
    params: fileId ? { fileId } : {}
  })
}

/**
 * 增加浏览量
 */
export function incrementWikiViews(id) {
  return request({
    url: `/api/wikis/${id}/views`,
    method: 'put'
  })
}

